import type { HandlerFn } from "..";
import { submitBulkAction } from "../../api";

export const submitFormHandler: HandlerFn = (ctx) => {
  submitBulkAction(
    window.location.pathname,
    ctx.actionName,
    ctx.selectedRows.map((r) => r.pk),
    Object.keys(ctx.optionValues).length > 0 ? ctx.optionValues : undefined,
    ctx.selectAcross,
  );
};
